import { CONTACT } from "../../lib/contact";
import { useT } from "../../i18n/LanguageContext";

export default function Footer() {
    const year = new Date().getFullYear();
    const { t } = useT();
    const siteLinks = t("footer.siteLinks");

    return (
        <footer data-testid="site-footer" data-cta-source="footer" className="bg-ink text-sand">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
                <div className="md:col-span-5">
                    <div className="font-serif text-4xl md:text-5xl tracking-tight">
                        gfirem<span className="text-terracotta">.</span>
                    </div>
                    <p className="mt-6 text-sand/70 leading-relaxed max-w-md">
                        {t("footer.tagline")}
                    </p>
                    <p className="mt-6 text-sand/50 text-sm">
                        {CONTACT.location} · {t("footer.location")}
                    </p>
                    <p
                        data-testid="footer-parent-company"
                        className="mt-5 text-sand/45 text-xs tracking-[0.16em] uppercase"
                    >
                        {t("footer.partOf")}
                    </p>
                </div>

                <div className="md:col-span-3">
                    <p className="overline text-sand/60 mb-5">{t("footer.siteLabel")}</p>
                    <ul className="space-y-3 text-sand/80">
                        {siteLinks.map(([h, l]) => (
                            <li key={h}>
                                <a href={h} className="link-underline">
                                    {l}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <p className="overline text-sand/60 mb-5">{t("footer.reachLabel")}</p>
                    <ul className="space-y-3 text-sand/85">
                        <li>
                            <a
                                href={CONTACT.calendlyHref}
                                target="_blank"
                                rel="noreferrer"
                                className="link-underline"
                                data-testid="footer-calendly-link"
                            >
                                {t("footer.bookCall")} →
                            </a>
                        </li>
                        <li>
                            <a
                                href={CONTACT.whatsappHref}
                                target="_blank"
                                rel="noreferrer"
                                className="link-underline"
                                data-testid="footer-whatsapp-link"
                            >
                                WhatsApp · {CONTACT.whatsappNumber}
                            </a>
                        </li>
                        <li>
                            <a
                                href={CONTACT.emailHref}
                                className="link-underline"
                                data-testid="footer-email-link"
                            >
                                {CONTACT.email}
                            </a>
                        </li>
                        <li>
                            <a
                                href={CONTACT.linkedin}
                                target="_blank"
                                rel="noreferrer"
                                className="link-underline"
                                data-testid="footer-linkedin-link"
                            >
                                LinkedIn
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-sand/15">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-sand/55">
                    <p>
                        © {year} GFireM. {t("footer.copy")}
                    </p>
                    <p className="font-serif italic text-sand/70">{t("footer.quote")}</p>
                </div>
            </div>
        </footer>
    );
}
